import type { EventKind, NodeKind } from './types'

/** Per-category node colors. Centralized so nothing else hardcodes hex. */
export const CATEGORY_COLORS: Record<NodeKind, string> = {
  company: '#7c6cff',
  database: '#3b82f6',
  email: '#f59e0b',
  app: '#22c55e',
  user: '#06b6d4',
  agent: '#d946ef'
}

/** Order the legend + drives a stable category iteration. */
export const CATEGORY_ORDER: NodeKind[] = [
  'company',
  'database',
  'email',
  'app',
  'user',
  'agent'
]

/** Event dot/ring colors. warn/error drive the node alert ring. */
export const EVENT_KIND_COLORS: Record<EventKind, string> = {
  ok: '#22c55e',
  info: '#3b82f6',
  warn: '#f59e0b',
  error: '#ef4444',
  action: '#d946ef'
}

export const NODE_RADIUS: Record<NodeKind, number> = {
  company: 30,
  database: 15,
  email: 14,
  app: 15,
  user: 12,
  agent: 13
}

/** d3-force tuning. */
export const FORCE = {
  linkDistance: 92,
  linkDistanceFlow: 106,
  linkStrength: 0.4,
  charge: -380,
  collidePadding: 20,
  /** keep a tiny floor so the graph never goes fully static (ambient drift) */
  alphaMin: 0.0015,
  /** higher floor used under prefers-reduced-motion so it settles + stops */
  alphaMinReduced: 0.02
} as const

export const STAGE_HEIGHT = 540
export const DETAIL_WIDTH = 280
/** Horizontal space reserved on the left for the always-visible live card. */
export const LEFT_RESERVED = 248

/** Live engine cadence. */
export const EVENT_INTERVAL_MS = 2200
export const ALERT_COOLDOWN_MS = 9000
export const TICKER_MAX = 30
export const TICKER_VISIBLE = 6
export const NODE_ACTIVITY_MAX = 8
/** How long an edge particle stays alive after a ping (ms). */
export const PARTICLE_TTL_MS = 1100

/** Cap real records so layout stays light; overflow collapses to a "+N" node. */
export const MAX_APP_NODES = 6
export const MAX_USER_NODES = 4
